import { BaseTicketController } from '../../../../common/base/ticketController';
import _ from 'lodash';

export class DownloadBalanceListController extends BaseTicketController {
  constructor(
    controllerService,
    ticketService,
    fileResponseService,
    $q
  ) {
    'ngInject';
    super({
      controllerService,
      ticketService,
      fileResponseService,
      $q
    });
  }

  $onInit() {
    super.$onInit();

    this.ticketService.load(this.$stateParams.ticketId).then(result => {
      this.ticket = result;
    });
  }

  downloadDocument() {
    const { ticketService, fileResponseService } = this;

    let doc = _.find(this.ticket.documents, {description: 'TRANSACTION_DATA'});
    if (angular.isDefined(doc)) {
      ticketService
        .downloadDocument(doc.url)
        .busy(this, 'isDownloadBusy')
        .then(file => fileResponseService.saveAs(file));
    }
  }

  completeTicket() {
    this.ticketService.completeIncoming(this.ticket.id);
  }
}
